import React, { useState } from "react";
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import axios from "axios";

function Donation() {
  const [donationAmount, setDonationAmount] = useState(null);

  const directAmount=(val)=>{
    setDonationAmount(val)
  }

  const handleDonationAmountChange = (e) => {
    setDonationAmount(e.target.value);
  };

  const handleDonationSubmit = () => {
    alert('Thanks for Donating you have been rewarded 100 Shakti Points');
  };

  const checkoutHandler = async(e,amount)=>{
    e.preventDefault()
    if (amount===null) {
      return
    }
    console.log(amount)

    const { data: { key } } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/payments/getkey`)

    const {data:{order}} = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/payments/checkout`,{
      amount
    })

    const options = {
            key,
            amount: order.amount,
            currency: "INR",
            name: "Sujal Patil",
            description: "Lets help the needy",
            image: "https://avatars.githubusercontent.com/u/25058652?v=4",
            order_id: order.id,
            callback_url: `${process.env.REACT_APP_API_BASE_URL}/payments/paymentverification`,
            prefill: {
                name: "Sujal Patil",
                email: "sujal.patil@example.com",
                contact: "8329075754"
            },
            notes: {
                "address": "Razorpay Corporate Office"
            },
            theme: {
                "color": "#121212"
            }
        };

    const razor = new window.Razorpay(options);
    razor.open();
    }
  return (
    <div className='w-screen' >
      <Navbar />
      <div className="bg-[#FAF7F0] dark:bg-[#010409]">
          <div class="h-screen w-screen flex">
            
            <div class="flex w-full p-10 justify-center items-center bg-gradient-to-br to-[#FAF7F0] from-blue-800">
              <form>
                <div>
                  <h1 class="text-gray-700 font-bold text-4xl font-sans my-4">Help us help you</h1>
                  <p class="text-gray-700 mt-1 text-xl font-base">Every donation brings us closer to our goal</p>
                </div>
                <h1 class="text-gray-700 font-bold text-2xl mb-1">Make a Donation</h1>
                <p class="text-sm font-normal text-gray-600 mb-7">Your support is invaluable</p>
                <div className="grid grid-cols-2 gap-x-4 gap-y-2">
                  <div onClick={()=>{directAmount(100)}} class="cursor-pointer flex items-center justify-center border-2 border-black py-2 px-3 rounded-2xl text-black font-bold">
                    100 Rs.
                  </div>
                  <div onClick={()=>{directAmount(500)}} class="cursor-pointer flex items-center justify-center border-2 border-black py-2 px-3 rounded-2xl  text-black font-bold">
                    500 Rs.
                  </div>
                  <div onClick={()=>{directAmount(1000)}} class="cursor-pointer flex items-center border-2 justify-center border-black py-2 px-3 rounded-2xl  text-black font-bold">
                    1000 Rs.
                  </div>
                  <div onClick={()=>{directAmount(2000)}} class="cursor-pointer flex items-center border-2 justify-center border-black py-2 px-3 rounded-2xl  text-black font-bold">
                    2000 Rs.
                  </div>

                </div>

                <div class="flex items-center border-2 border-black py-2 px-3 rounded-2xl mt-4">
                  <input
                    type="number"
                    class="pl-2 outline-none border-none flex-1 bg-transparent font-bold text-black"
                    placeholder="Enter amount you wish"
                    value={donationAmount}
                    onChange={handleDonationAmountChange}
                    required
                  />
                  <span class="text-gray-500 font-bold text-lg">Rs.</span>
                </div>
                <button onClick={(e)=>{checkoutHandler(e,donationAmount)}} className="block w-full items-center justify-center text-[#d7dfe7] bg-[#08161f] font-bold py-2 pl-4 hover:bg-[#0d212e] rounded-xl h-10 my-4 cursor-pointer transition-all px-6 border-green-400 border-b-[4px] hover:brightness-110 hover:-translate-y-[1px] hover:border-b-[6px] active:border-b-[2px] active:brightness-90 active:translate-y-[2px] hover:shadow-lg hover:shadow-green-600 shadow-green-800 active:shadow-none">
                  Donate
                </button>
              </form>
            </div>
          </div>
        </div>
      <Footer />
    </div>
  );
}

export default Donation;


// rzp_test_j36tFuKgsyOAzC
// secret 5p6NHeWpubbLUzjB11ynnKuG
